import { BusIcon } from './BusIcon';

/**
 * author: Google
 * id F6516F38-B29E-4CC9-A7E2-706817121D45
 * name bus
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bus.svg
 * tags
 * - Navigation 
 * - Transportation + Road 
 */
export const DirectionsBusIcon = BusIcon;
export default DirectionsBusIcon